import { render, staticRenderFns } from "./settingTemplateOfferPage.vue?vue&type=template&id=4c6a5ff7&scoped=true&"
import script from "./settingTemplateOfferPage.vue?vue&type=script&lang=js&"
export * from "./settingTemplateOfferPage.vue?vue&type=script&lang=js&"
import style0 from "./settingTemplateOfferPage.vue?vue&type=style&index=0&id=4c6a5ff7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a5ff7",
  null
  
)

export default component.exports